// https://www.npmjs.com/package/vanilla-lazyload
import * as MerchLazyLoad from "vanilla-lazyload";
var lazyLoadInstance = new MerchLazyLoad({
  elements_selector: ".lazy",
  threshold: -40,
  class_loaded: "fade"
});